export default {
  'insurers.filters.active': 'Active',
  'insurers.filters.active.options.active': 'Active',
  'insurers.filters.active.options.inactive': 'Inactive',
  'insurers.filters.cnpj': 'CNPJ',
  'insurers.filters.fantasyName': 'Fantasy name',
  'insurers.filters.order': 'Order by',
  'insurers.filters.order.options.asc': 'ASC',
  'insurers.filters.order.options.desc': 'DESC',
  'insurers.list.header.cnpj': 'CNPJ',
  'insurers.list.header.name': 'Name',
  'insurers.list.header.fantasyName': 'Fantasy Name',
  'insurers.list.header.email': 'E-mail',
  'insurers.list.header.phone': 'Phone',
  'insurers.list.header.actions': 'Actions',
  'insurers.list.column.actions.button': 'View/Edit',
  'insurers.searchBar.generateReport': 'Generate report',
  'insurers.searchBar.button': 'New insurer',
  'insurers.general.form.name': 'Name',
  'insurers.general.form.fantasyName': 'Fantasy name',
  'insurers.general.form.cnpj': 'CNPJ',
  'insurers.general.form.stateRegistration': 'State registration',
  'insurers.general.form.cityRegistration': 'City registration',
  'insurers.general.form.email': 'E-mail',
  'insurers.general.form.refactoringMargin': '(%) Refactoring Margin',
  'insurers.general.form.website': 'Website',
  'insurers.general.form.observation': 'Observation',
  'insurers.create.notification.success':
    'Insurance company created successfully!',
  'insurers.create.notification.successDescription':
    'The new insurance company was successfully registered!',
  'insurers.update.notification.success': 'Success!',
  'insurers.update.notification.successDescription':
    'Insurance company updated successfully!',
  'insurers.remove.modal.title': 'Remove insurer',
  'insurers.remove.modal.content': 'Do you really want to remove the insurer',
  'insurers.remove.modal.button.ok': 'Remove',
  'insurers.remove.notification.success': 'Success!',
  'insurers.remove.notification.successDescription':
    'Insurer successfully removed!',
  'insurers.activate.message.success': 'Insurer successfully activated!',
  'insurers.inactivate.message.success': 'Insurer successfully inactivated!',

  'insurers.contacts.list.header.contactType': 'Contact type',
  'insurers.contacts.list.header.value': 'Contact',
  'insurers.contacts.list.header.name': 'Name',
  'insurers.contacts.list.header.actions': 'Actions',
  'insurers.contacts.list.actions.buttons': 'Edit',
  'insurers.contacts.list.actions.buttons.remove': 'Remove',
  'insurers.contacts.contactTypes.email': 'E-mail',
  'insurers.contacts.contactTypes.mobile': 'Mobile',
  'insurers.contacts.contactTypes.fax': 'Fax',
  'insurers.contacts.contactTypes.phone': 'Phone',
  'insurers.contacts.contactTypes.whatsapp': 'WhatsApp',
  'insurers.contacts.modal.create.title': 'New contact',
  'insurers.contacts.modal.update.title': 'Edit contact',
  'insurers.contacts.modal.okText': 'Save contact',
  'insurers.contacts.modal.cancelText': 'Cancel',
  'insurers.contacts.remove.modal.title': 'Remove contact',
  'insurers.contacts.remove.modal.content':
    'Do you really want to remove this contact?',
  'insurers.contacts.remove.modal.okText': 'Remove contact',
  'insurers.contacts.create.notification.success':
    'Contact created successfully!',
  'insurers.contacts.create.notification.successDescription':
    'The new contact was created successfully.',
  'insurers.contacts.update.notification.success':
    'Contact updated successfully!',
  'insurers.contacts.update.notification.successDescription':
    'The contact was successfully updated.',
  'insurers.contacts.remove.notification.success':
    'Contact successfully removed!',
  'insurers.contacts.remove.notification.successDescription':
    'The contact was successfully removed.',

  'insurers.addresses.list.header.zipCode': 'Zip code',
  'insurers.addresses.list.header.cityId': 'City',
  'insurers.addresses.list.header.street': 'Street',
  'insurers.addresses.list.header.number': 'Number',
  'insurers.addresses.list.header.main': 'Main address',
  'insurers.addresses.list.header.actions': 'Action',
  'insurers.addresses.list.actions.buttons': 'Edit',
  'insurers.addresses.list.actions.buttons.remove': 'Remove',
  'insurers.addresses.modal.create.title': 'New address',
  'insurers.addresses.modal.update.title': 'Edit address',
  'insurers.addresses.modal.okText': 'Save address',
  'insurers.addresses.modal.cancelText': 'Cancel',
  'insurers.addresses.form.cityId': 'City',
  'insurers.addresses.form.complement': 'Complement',
  'insurers.addresses.form.delivery': 'Delivery?',
  'insurers.addresses.form.description': 'Description',
  'insurers.addresses.form.id': 'State',
  'insurers.addresses.form.main': 'Main address?',
  'insurers.addresses.form.number': 'Number',
  'insurers.addresses.form.district': 'District',
  'insurers.addresses.form.street': 'Street',
  'insurers.addresses.form.zipCode': 'Zip code',
  'insurers.addresses.remove.modal.title': 'Remove address',
  'insurers.addresses.remove.modal.content':
    'Do you really want to remove this address?',
  'insurers.addresses.remove.modal.okText': 'Remove address',
  'insurers.addresses.create.notification.success':
    'Address created successfully!',
  'insurers.addresses.create.notification.successDescription':
    'The new address was created successfully.',
  'insurers.addresses.update.notification.success':
    'Address updated successfully!',
  'insurers.addresses.update.notification.successDescription':
    'The address was successfully updated.',
  'insurers.addresses.remove.notification.success':
    'Address successfully removed!',
  'insurers.addresses.remove.notification.successDescription':
    'The address was successfully removed.',

  'insurers.modal.selectedInsurers.title.add': 'Add Insurer',
  'insurers.modal.selectedInsurers.search': 'Search for Insurers',
};
